<script lang="ts">
  // Round initial avatar that doubles as the row checkbox (spec §9 "Row"):
  // the initial of the name (or address) upper-cased, or a check icon while selected.
  import { initialOf } from '$lib/mail/format';
  import Icon from './Icon.svelte';

  let {
    name = '',
    addr = '',
    sel = false,
    checked = 'false',
    role = 'checkbox',
    label = '',
    onclick,
  }: {
    name?: string | null;
    addr?: string | null;
    sel?: boolean;
    checked?: 'true' | 'false' | 'mixed';
    role?: string;
    label?: string;
    onclick?: (ev: MouseEvent) => void;
  } = $props();

  const initial = $derived(initialOf(name, addr));
</script>

<span class="avatar" class:sel {role} tabindex="-1" aria-checked={role === 'checkbox' ? checked : undefined} aria-label={label || undefined} {onclick}>
  {#if sel}<Icon name="check" size={18} />{:else}{initial}{/if}
</span>

<style>
  /* @css ui/Avatar start */
  .avatar.sel {
    background: var(--blue-500);
    color: #fff
  }

  .avatar {
    cursor: pointer;
    width: var(--control-md);
    height: var(--control-md);
    border-radius: var(--radius-pill);
    background: var(--blue-100);
    color: var(--blue-700);
    display: grid;
    place-items: center;
    font-weight: var(--weight-semibold);
    flex: none
  }

  :global(html.tik-dark) .avatar {
    background: var(--blue-900);
    color: var(--blue-200)
  }
  /* @css ui/Avatar end */
</style>
